var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTypography(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "currentColor",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.083 41.667v2.083c0 .59-.2 1.085-.6 1.485-.4.4-.894.6-1.483.598-.59 0-1.085-.2-1.485-.6-.4-.4-.6-.894-.598-1.483v-8.333c0-.59.2-1.086.6-1.486.4-.4.894-.6 1.483-.598.59 0 1.085.2 1.485.6.4.4.6.895.598 1.484V37.5h14.584c.59 0 1.085.2 1.485.6.4.4.6.894.598 1.483 0 .59-.2 1.086-.6 1.486-.4.4-.894.599-1.483.598H27.083Zm-18.75 0c-.59 0-1.085-.2-1.485-.6-.4-.4-.6-.895-.598-1.484 0-.59.2-1.085.6-1.485.4-.4.894-.6 1.483-.598h8.334c.59 0 1.085.2 1.485.6.4.4.6.894.598 1.483 0 .59-.2 1.086-.6 1.486-.4.4-.894.599-1.483.598H8.333ZM20 22.76h10.052l1.77 5.104c.14.383.383.695.73.938s.73.365 1.146.365c.694 0 1.25-.296 1.667-.886.416-.59.486-1.215.208-1.875L27.76 5.521a2.218 2.218 0 0 0-.78-.99 2.037 2.037 0 0 0-1.199-.364H24.22c-.452 0-.85.121-1.198.364a2.218 2.218 0 0 0-.781.99l-7.865 20.937c-.243.66-.165 1.277.235 1.85.4.574.947.86 1.64.859.451 0 .842-.122 1.173-.365.33-.243.582-.573.754-.99L20 22.76Zm1.25-3.593 3.646-10.365h.208l3.646 10.365h-7.5Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypography);
export default __webpack_public_path__ + "static/media/typography.135b034d42ad4b17916389acc7d1a5a8.svg";
export { ForwardRef as ReactComponent };